(function () {
	'use strict';

    angular.module("imApp").factory("consignmentPlanService", ['$q', '$ihttp', function ($q, $ihttp) {
		let service = {
			selectEquipmentList: [],
			isSearchingEquipments: false,
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1362,
                    parameters: parms || {}
                });
            },
            listStockPlaces: function (parms) {
                return $ihttp.post({
                    method: 453,
                    parameters: parms || {}
                });
            },
            listOnPlans: function (parms) {
                return $ihttp.post({
                    method: 1416,
                    parameters: parms || {}
                });
            },
			updateOrder: function (parms) {
				var deferred = $q.defer();

				var parms_genericFunction = {
					method: 1442,
					parameters: parms
				};

				$ihttp.post(parms_genericFunction).then(function (data) {
					service.loaded = true;
					deferred.resolve(data);
				});

				return deferred.promise;
			},
			searchEquipments: function (equipmentName, businessCoNo) {
				var deferred = $q.defer();

				service.isSearchingEquipments = true;

				$ihttp.post({
					method: 1365, parameters: {
						equipment_name: equipmentName,
						businessco_no: businessCoNo || ''
					}
				}).then(function (data) {
					angular.copy(data, service.selectEquipmentList);

					service.isSearchingEquipments = false;

					deferred.resolve(data);
				});

				return deferred.promise;
			},
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1363,
                    parameters: edit
                });
            }
		};

		return service;
	}]);
})();
